// extracted by mini-css-extract-plugin
export default {"btn_home":"Home_btn_home__x5a51"};